'use strict';

export default function() {
  function findRetailers(qs) {
    window.loadingIndicator.show($('.sprocket__input-modal-inner'));
    var queryString = '';
    if (!qs) {
      var defaultLocation = JSON.parse($('#geolocation').val());
      if (defaultLocation.city) {
        queryString += defaultLocation.city + ' ';
      }
      if (defaultLocation.region_name) {
        queryString += defaultLocation.region_name + ' ';
      }
      if (defaultLocation.zip_code) {
        queryString += defaultLocation.zip_code;
      }
      $('.sprocket__input-modal-search-input').val(queryString);
    } else {
      queryString = qs;
    }

    function transformRetailerData(obj, du) {
      return {
        storeID: obj.name,
        displayName: obj.displayName,
        elpURL: obj.url,
        address: obj.address.formattedAddress,
        distance: obj.formattedDistance,
        distanceUnit: du,
        phoneNumber: obj.address.phone,
      };
    }

    $.ajax({
      type: 'GET',
      url: '/electra-store-finder/json/?q=' + queryString,
      success: function(response) {
        window.loadingIndicator.hide();
        var retailers = [];
        if (response.searchPageData !== null) {
          retailers = response.searchPageData.results;
        }
        var stores = [];

        if (response.preferredStore) {
          var pr = JSON.parse(localStorage.getItem('customerPreferredRetailer'));
          pr = transformRetailerData(pr.data);
          $(pr).attr('preferred', 'preferred');
          stores.push(pr);
        }

        for (var i = 0; i < retailers.length; i++) {
          var rtlr = transformRetailerData(retailers[i], response.distanceUnit);
          if (retailers[i].name === $('#customerPreferredRetailerId').val()) {
            $(rtlr).attr('isPreferred', 'true');
          }
          stores.push(rtlr);
        }

        //Compile the template
        if (retailers.length === 0) {
          $('.sprocket__input-modal-inner').html(
            "<p class='sprocket__modal-error'>No results<br>Sorry, we couldn't find any results for your search.</p>"
          );
        } else {
          let result = '';

          const storeFinderProductMyPref = $('#findRetailerstoreFinderProductMyPref').html();
          const retailer = $('#findRetailerRetailer').html();
          const storeFinderLabelDistance = $('#findRetailerStoreFinderLabelDistance').html();
          const storeFinderProductSetAsPref = $('#findRetailerStoreFinderProductSetAsPref').html();

          stores.forEach((store) => {
            result += `<div class="sku-modal-status--ibd--info ${
              store.preferred ? store.preferred : ''
            }" data-store-id="${store.storeID}">`;

            if (store.preferred) {
              result += `<p class="preferred-retailer--flag">${storeFinderProductMyPref}</p>`;
            }

            result += `<p class="shop-name">`;
            if (store.elpURL) {
              result += `<a href="${store.elpURL}" target="_blank" title="${retailer}">${store.displayName}</a>`;
            } else {
              result += `<span>${store.displayName}</span>`;
            }
            result += `</p>`;

            result += `<p class="shop-address">`;
            if (store.address) {
              result += `${store.address}`;
            }
            result += `</p>`;

            if (store.distance) {
              result += `<p class="shop-distance">
                ${storeFinderLabelDistance}: ${store.distance} ${store.distanceUnit}
            </p>`;
            }
            if (store.phoneNumber) {
              result += `<p class="sprocket__msg-inquire">
              <a href="tel:${store.phoneNumber}">
                  ${store.phoneNumber}
              </a>
          </p>`;
            }
            if (!store.preferred) result += `<div>`;
            if (store.isPreferred) {
              result += `<a class="is-preferred button hollow black"><i class="md-24 button-icon">done</i>
                  <span>${storeFinderProductMyPref}</span></a>`;
            } else {
              if (!store.preferred) {
                result += `<a class="set-preferred button hollow black">
                <span>${storeFinderProductSetAsPref}</span></a>`;
              }
            }
            result += `</div></div>`;
          });

          $('.sprocket__input-modal-inner').html(result);
        }
      },

      error: function() {
        //TODO: something user friendly
        $('.sprocket__input-modal-inner').html(
          "<p class='sprocket__modal-error'>There was an error processing your request</p>"
        );
      },
    });
  }

  function setPreferredRetailer(id, ref) {
    $('.sprocket__input-modal-inner').html('');
    window.loadingIndicator.show($('.sprocket__input-modal-inner'));
    $.ajax({
      type: 'POST',
      url: '/store-finder/save-preferred-retailer/json/?storeName=' + id,
      success: function() {
        // use retailer-selected class to hide the link if on the Garage page
        $('.preferred-retailer--alert').addClass('retailer-selected');
        $('#customerPreferredRetailerId').val(id);
        getPreferredRetailer();
        findRetailers($('.sprocket__input-modal-search-input').val());
      },
      error: function() {
        window.console.log('couldnt set retailer: ' + id);
        $(ref).prepend('<i class="md-18 button-icon">error</i>');
      },
    });
  }

  function getPreferredRetailer() {
    $.ajax({
      type: 'GET',
      url: '/store-finder/get-preferred-retailer/',
      success: function(data) {
        localStorage.setItem('customerPreferredRetailer', JSON.stringify(data));
      },
      error: function() {},
    });
  }

  $(document).ready(function() {
    //set the preferred retailer into local storage for quicker access
    getPreferredRetailer();
    $('.sprocket__input-modal-inner').on('click', '.set-preferred', function() {
      var retailerId = $(this)
        .parent()
        .parent()
        .attr('data-store-id');
      setPreferredRetailer(retailerId, $(this));
      // put checkmark next to Garmin's guide's 3rd step
      $('.integrations-walkthru__list > .preferred-retailer-step')
        .removeClass('li-counter')
        .addClass('li-checkmark');
    });
  });

  $('#input-modal').on(
    'open.zf.reveal',
    window.Foundation.util.throttle(function() {
      $('.sprocket__input-modal-inner').html('');
      $('.sprocket__input-modal-search-input').val('');
      findRetailers();
    }, 0)
  );

  $('.sprocket__input-modal-search-button').on('click', function() {
    findRetailers($('.sprocket__input-modal-search-input').val());
  });
  $('.sprocket__input-modal-search-input').keydown(function(e) {
    // if user hits Enter instead of clicking 'search'
    if (e.keyCode === 13) {
      e.preventDefault();
      findRetailers($('.sprocket__input-modal-search-input').val());
    }
  });
}
